import * as angular from "angular";

export class GroupColorDataProvider {
    public readonly groupColours = [
        "#E53935", // strong red
        "#D81B60", // deep pink
        "#8E24AA", // rich purple
        "#5E35B1", // indigo
        "#3949AB", // royal blue
        "#1E88E5", // vivid blue
        "#039BE5", // cyan blue
        "#00897B", // teal
        "#2E7D32", // dark green
        "#558B2F", // olive green
        "#9E9D24", // mustard
        "#F9A825", // amber
        "#FB8C00", // orange
        "#EF6C00", // deep orange
        "#6D4C41", // brown
        "#546E7A", // blue grey
        "#37474F", // charcoal
        "#C62828", // dark red
        "#AD1457", // wine
        "#4527A0", // deep violet
        "#696969", // default grey
    ];

    randomColor(): string {
        const rand = Math.floor(Math.random() * this.groupColours.length);
        return this.groupColours[rand];
    }
}

angular
    .module("vcDataProvider")
    .service("GroupColorDataProvider", GroupColorDataProvider);
